import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OInfoCards } from '../components/organisme';

import { setCmsHead } from '../redux/head/headActions';
import { CMS_CONFIG } from '../config/cms.config';
import withAuthGuard from '../helpers/withAuthGuard';

class ProductCategoryPage extends React.Component {
	componentDidMount() {
		this.props.setCmsHead({ title: 'Producten' });
	}

	render() {
		return (
			<div className="layout-cms--content-body layout-cms--content-body-grey">
				<OInfoCards items={CMS_CONFIG.PRODUCT_CATEGORIES} />
			</div>
		);
	}
}

ProductCategoryPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(null, {
	setCmsHead,
})(ProductCategoryPage)));



// WEBPACK FOOTER //
// ./src/CMS/product-category.page.js